import { PageHeader } from '@redturtle/iovisit-theme/components/Views';

const TitleBlockView = ({ properties, metadata }) => {
  // return <PageHeader content={metadata || properties} />;
  return;
};

export default TitleBlockView;
